<template>
  <section ref="twoContainer" class="two-page-section media_section_height">
    <div class="media_screen_style" style="
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 32px;
      ">
      <!-- 译牛灵犀 -->
      <div class="tow_top_title">
        <slot name="heard"></slot>

      </div>

      <!-- <div style="color: #FEF8F8;font-size: 14px;margin-bottom: 32px;">创建好对话之后，其他人扫码加入即可</div> -->

      <div class="two_img_bg">
        <img src="../assets/1.webp" width="300px" alt="" />

        <!-- 上 -->
        <div :class="['qr_box', hasAnimated ? 'tow_slide_in' : '']">
          <div class="box_left">
            <div class="box_left_left">
              <img src="../assets/scan_qr.svg" style="margin-top: 6px" width="40px" alt="" />
            </div>
            <div class="box_left_right">
              <div style="
                  color: #40fff9;
                  font-size: 16px;
                  font-weight: 500;
                  margin-bottom: 6px;
                ">

                {{ t("two.qr") }}
              </div>
              <div style="font-size: 10px">Scan QR code to JOlN session</div>
            </div>
          </div>
          <div class="box_right">
            <img src="../assets/icon_gengduo.svg" style="margin-right: 12px; margin-top: 6px" width="25px" alt="" />
          </div>
        </div>
        <!-- 下 -->
        <div :class="['ai_box', hasAnimated ? 'tow_slide_in_right' : '']">
          <div class="box_left">
            <div class="box_left_left">
              <img src="../assets/dialogue.svg" style="margin-top: 6px" width="40px" alt="" />
            </div>
            <div class="box_left_right">
              <div style="
                  color: #6a36f2;
                  font-size: 16px;
                  font-weight: 500;
                  margin-bottom: 6px;
                ">
                {{ t("two.ai") }}
              </div>
              <div style="font-size: 10px">
                CREATE Simultaneous Interpret-ation session
              </div>
            </div>
          </div>
          <div class="box_right">
            <img src="../assets/icon_gengduo1.svg" style="margin-right: 12px; margin-top: 6px" width="25px" alt="" />
          </div>
        </div>
      </div>
      <!-- 下载按钮 -->
      <slot name="download"></slot>
    </div>
    <div class="tip_text_box">
      <slot name="tip"></slot>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from "vue";
const twoContainer = ref(null);


const hasAnimated = ref(false);
import { useI18n } from "vue-i18n";

const { t, locale } = useI18n();
const lang = ref("zh");
if (locale.value != 'zh-CN' && locale.value != 'zh') {
  lang.value = "en";
}

// const text = {
//   zh: {
//     title: "译牛灵犀",
//   },
//   en: {
//     title: "eNewie LingXi",
//   }
// }

// const gifShow = ref(false);
onMounted(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting && !hasAnimated.value) {
        setTimeout(() => {
          hasAnimated.value = true;
        }, 1000);
        observer.disconnect();
      }
    },
    {
      threshold: [0.9, 0.5],
    }
  );

  if (twoContainer.value) {
    observer.observe(twoContainer.value);
  }
});
</script>

<style scoped>
.two-page-section {
  position: relative;
  /* transform: scale(.7);
    transform-origin: top; */
  /* height: 100vh; */
  text-align: center;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  /* margin-top: 32px; */
  /* min-height: 932px; */
}

.tip_text_box {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translate(-50%, -10px);
  animation: useTextBoxslideDown 2s linear infinite;
}

@keyframes useTextBoxslideDown {
  0% {
    transform: translate(-50%, -10px);
    opacity: 0.9;
  }

  50% {
    transform: translate(-50%, -5px);
    opacity: 1;
  }

  100% {
    transform: translate(-50%, 0);
    opacity: 0.9;
  }
}

.two_img_bg {
  /* transform: scale(0.96);
    transform-origin: top; */
  position: relative;
  width: 300px;
  height: 666px;
}

.qr_box {
  transition: opacity 2s ease;
  opacity: 0;
  position: absolute;
  bottom: 139px;
  /* background-color: rgba(19, 18, 18, 0.527); */
  width: 262px;
  height: 74px;
  left: 50%;
  transform: translate(-50%, 0%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  background-image: url("../assets/bg_pic_canguanfang.png");
  background-size: cover;
  /* 拉伸填满容器 */
  background-position: center;
  /* 居中显示 */
  background-repeat: no-repeat;
  /* 不重复 */
}

.ai_box {
  transition: opacity 2s ease;
  opacity: 0;
  position: absolute;
  bottom: 33px;
  /* background-color: rgba(233, 127, 127, 0.527); */
  width: 262px;
  height: 83px;
  left: 50%;
  transform: translate(-50%, 0%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px;
  background-image: url("../assets/bg_pic_zhubanfang.png");
  background-size: cover;
  /* 拉伸填满容器 */
  background-position: center;
  /* 居中显示 */
  background-repeat: no-repeat;
  /* 不重复 */
}

.box_left {
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: start;
  margin-left: 12px;
}

.box_left_right {
  margin-left: 10px;
  /* margin-bottom: 4px; */
}

/* 动画 */

.tow_slide_in {
  position: absolute;
  left: 50%;
  /* 初始定位 */
  transform: translate(-80%, 0);
  /* 初始偏移到左边 */
  animation: twoSlideInFromLeft 0.5s ease-out forwards;
}

@keyframes twoSlideInFromLeft {
  0% {
    opacity: 0;
    transform: translate(-80%, 0);
  }

  100% {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

.tow_slide_in_right {
  animation: twoSlideInFromRight 1.5s ease-out forwards;
}

@keyframes twoSlideInFromRight {
  0% {
    opacity: 0;
    left: 100%;
    transform: translate(-50%, 0);
  }

  50% {
    opacity: 0.5;
    left: -20%;
    transform: translate(20%, 0%);
  }

  100% {
    opacity: 1;
    left: 50%;
    transform: translate(-50%, 0%);
  }
}

/* .gift_img_box {
    position: absolute;
    bottom: 228px;
    right: 20px;
    z-index: 100;
    animation: giftImgBoxScale 1.5s infinite ease-in-out;
} */

@keyframes giftImgBoxScale {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
